import React from "react";
import "./ClipBoardButton.scss";

const ClipBoardButton: React.FC = () => {
  const SharedUrl: any = React.useRef(null);

  React.useEffect(() => {
    SharedUrl.current.value = window.location.href;
  }, []);

  const onClick = () => {
    SharedUrl.current.select();
    document.execCommand("copy");
    SharedUrl.current.blur();
    alert("URL이 클립보드에 복사되었습니다");
  };

  return (
    <div className="ClipBoardButton">
      <input
        type="text"
        value={window.location.href}
        ref={SharedUrl}
        onChange={(e) => null}
        readOnly
      />
      <button type="button" onClick={onClick}>
        URL복사
      </button>
    </div>
  );
};

export default ClipBoardButton;
